import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 194059D5-3FF9-4DA7-8C7E-81092D38889B
 * name credit-card-settings
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-settings.svg
 * tags
 * - Banking 
 * - Settings 
 */
export const CreditCardSettingsIcon = createSvgIcon(<><path d="M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 11H4V8H20M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15Z" /></>, 'CreditCardSettingsIcon');
export default CreditCardSettingsIcon